module.exports = __webpack_public_path__ + "img/course-sample.2f79df02.png";